import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  referencesList: null,
  referencesListError: null,
  success: null,
  error: null
};

export const referencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_REFERENCES_LIST_START:
      return {...state, loading: true, referencesListError: null};
    case actionTypes.GET_REFERENCES_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        referencesListError: null,
        referencesList: action.payload,
      }
    }

    case actionTypes.GET_REFERENCES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        referencesListError: action.payload,
        referencesList: null,
      };

    case actionTypes.ADD_NEW_REFERENCE_START:
      return {...state, loading: true, success: null, error: null};
    case actionTypes.ADD_NEW_REFERENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        error: null
      };
    case actionTypes.ADD_NEW_REFERENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };
      case actionTypes.EDIT_REFERENCE:
      return { ...state,
         loading: true, 
         error: null, 
         success: null
         };

    case actionTypes.REFERENCE_MESSAGE_HANDLER:
      return {
        ...state,
        referencesListError: action.payload,
        error: action.payload,
        success: action.payload,
      };
    default:
      return {...state};
  }
};
